import React from 'react';
import { heroData } from '../data';
import { motion as m } from 'framer-motion';
import { fadeIn, staggerContainer } from '../variants';
import useMediaQuery from '../hooks/useMediaQuery';
import AnchorLink from 'react-anchor-link-smooth-scroll';

{/*import Devi from '../assets/img/waves.svg'*/}

const Hero = ({ setSelectedPage }) => {

  const isAboveMediumScreens = useMediaQuery('(min-width: 1080px)')
  const { pretitleImage, title, subtitle, btnText } = heroData;
  return( 

  <section id='howdy' className='cursor-default	relative h-screen bg-hero bg-fixed bg-cover overflow-hidden'>

    <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-70"></div>

    <div className='container mx-auto min-h-[100vh] flex justify-center items-center'>

      <m.div variants={staggerContainer(0.3, 1)}
      initial='hidden'
      whileInView={'show'} 
      className='z-10 text-center flex flex-col items-center'>

        <m.div variants={fadeIn('right', 'spring', 0.3, 1.1)} 
        className='mb-5'>{pretitleImage}</m.div>

        <m.h1 variants={fadeIn('down', 'tween', 0.3, 1.1)}
        className='h1 mb-5 text-[24px] lg:text-[30px]'>{title}</m.h1>

        <m.p variants={fadeIn('down', 'tween', 0.4, 1.1)}
        className='text-white max-w-[540px] mb-5'>{subtitle}</m.p>

        <m.div variants={fadeIn('left', 'tween', 0.5, 1.1)}>
          <AnchorLink href="#menu"><button className='btn mt-5'>{btnText}</button></AnchorLink>
        </m.div>

      </m.div>

    </div>

  </section>
  );
};

export default Hero;
